import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { service } from "../../rbac-consts";
import { default as ClientServicesContainer } from "./client/ServicesContainer";
import { default as AdminServicesContainer } from "./admin/ServicesContainer";

const ServicesWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={service.ADMIN}
        yes={() => (
          <AdminServicesContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={service.USER}
        yes={() => (
          <ClientServicesContainer />
        )}
      />
    </>
  );
};

export default ServicesWrapper;